<template>
  <div class="mx-auto w-full max-w-(--breakpoint-sm) md:max-w-(--breakpoint-xl)">
    <div
      class="mx-auto flex flex-col justify-center text-center"
      :class="(index ?? 0) % 2 ? 'md:flex-row md:text-left' : 'md:flex-row-reverse md:text-right'"
    >
      <div v-if="article.image" class="w-full p-6 sm:p-12 md:w-1/2">
        <img class="w-full shadow-sm" :src="article.image" alt="Artikkelbilde" />
      </div>
      <div v-if="article.image" class="my-8 hidden md:block"></div>
      <div
        class="flex w-full flex-col justify-center p-6 sm:p-12 md:w-1/2"
        :class="!article.image ? 'text-center' : ''"
      >
        <h3 class="text-2xl font-semibold">{{ article.title }}</h3>
        <p class="v-html" v-html="article.text" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AboutArticle } from '../types'

type Props = { article: AboutArticle; index?: number }
defineProps<Props>()
</script>

<style lang="scss"></style>
